import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Paper, Checkbox, FormControlLabel, Grid } from "@mui/material";

import './styles.css';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : theme.palette.background.paper,
  ...theme.typography.body2,
  padding: 0,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: 12,
  cursor: 'pointer',
  // Keyboard focus ring on the card (the checkbox is visually hidden but kept
  // accessible via the sr-only style below).
  '&:focus-within': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

const ResponsiveMultiSelectCheckbox = ({ options, label, handleChange }) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    // console.log('label ', label)
    // setSelected([])
  }, [label])
  const handleSelect = (event) => {

    if (selected.includes(event.target.value)) {
      const selection = selected.filter((item) => item !== event.target.value)
      handleChange(event.target.name, selection)
       setSelected(selection)
    } else {
      handleChange(event.target.name, [...selected, event.target.value])
       
       setSelected([...selected, event.target.value]);
    }
    
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={1}>
        {options.map((option, i) => (
                <Grid key={`multiselect${option.value + i}i`} size={6}>
                  <Item style={{ border: selected.includes(option.value) ? '1px solid var(--vk-brand)' : '1px solid var(--vk-divider, #ccc)', color: selected.includes(option.value) ? 'var(--vk-brand)' : ''}}>
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              name={label}
                              checked={selected.includes(option.value)}
                              onChange={handleSelect}
                              value={option.value}
                              style={{ position: 'absolute', opacity: 0, width: 1, height: 1, margin: -1, padding: 0, overflow: 'hidden' }}
                            />
                          }
                          style={{ margin: 0, width: '100%', padding: '8px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center' }}
                          label={option.label}
                        />
                  </Item>
                </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default ResponsiveMultiSelectCheckbox;
